



























import Vue from "vue";
import { isDeliveryNoticeVisible } from "@/optimizedEncoding/scripts/helpers/deliveryNotice";

export default Vue.extend({
    name: "DeliveryNoticeBanner",
    data: function() {
        return {
            bannerVisible: isDeliveryNoticeVisible(),
        };
    },
});
